import React, { useState } from "react";
import successright from "../Images/check.png"; // Update the path as per your project structure
import copyIcon from "../Images/copymain.png";

const SuccessPopup = ({
  show,
  onClose,
  receiver,
  paymentMethod,
  amountPaid,
  transactionId,
  paymentTime, // New prop for payment time
  currency,
  title,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyTransactionId = () => {
    navigator.clipboard.writeText(transactionId);
    setCopied(true);

    // Reset the "Copied" text after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  // Format payment time to a user-friendly format
  const formatPaymentTime = (time) => {
    if (!time) return "N/A";
    const date = new Date(time);
    return new Intl.DateTimeFormat("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(date);
  };

  if (!show) return null;

  return (
    <div className="popup-outer">
      <div className="popup-overlay"></div>
      <div className="popup-inner">
        <div className="fs-1 payment_heaader">{title || "Payment Successful"}</div>
        <img loading="lazy" src={successright} alt="Success" className="" />
        <div className="inner-box mt-4">
          <h1 className="name">Payment Details</h1>
          <div className="orderbox">
            <ul className="list-group mb-3">
              <li className="list-group-item d-flex justify-content-between">
                <span>Receiver</span>
                <strong>{receiver || "N/A"}</strong>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Payment Method</span>
                <strong>{paymentMethod || "N/A"}</strong>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Amount Paid</span>
                <strong>
                  
                  {currency == "AED" ? (
                      <>
                      {amountPaid || "0.00"} {currency}
                      </>
                    ):(
                      <>
                      {currency}{amountPaid || "0.00"}
                      </>
                    )}
                </strong>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Transaction ID</span>
                <div>
                  <strong>{transactionId || "N/A"}</strong>
                  
                </div>
              </li>
              <li className="list-group-item d-flex justify-content-between">
                <span>Payment Time</span>
                <strong>{formatPaymentTime(paymentTime)}</strong>
              </li>
            </ul>
            <button
              type="button"
              className="Paybtn try_theme_btn mx-auto d-block submitclose"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;